import {Pipe, PipeTransform} from '@angular/core';
import {ProductionScheduleItemInPathGroup} from '@domain/production-schedule/production-schedule-item-in-path-group';
import {ProductionSchedulePathsOfColoredYarnSet} from '@domain/production-schedule/production-schedule-paths-of-colored-yarn-set';
import {OverviewListCreelPosition} from '@domain/textile-data/creel/overview-list-creel-position';
import {find, isNil, join, map} from 'lodash-es';

@Pipe({
  name: 'getProductionScheduleItemColor'
})
export class GetProductionScheduleItemColorPipe implements PipeTransform {
  public transform(productionScheduleItem: ProductionScheduleItemInPathGroup, productionScheduleColoredYarnSet: ProductionSchedulePathsOfColoredYarnSet, isMainColor: boolean): string {
    const creelPosition: OverviewListCreelPosition = find(productionScheduleColoredYarnSet.productionScheduleColoredYarnSet.coloredYarnSet.overviewListColorSet.creelPositions, [
      'position',
      isMainColor ? productionScheduleItem.mainColorPosition : productionScheduleItem.borderColorPosition
    ]);

    return !isNil(creelPosition) ? join(map(creelPosition.getUniqueItems(), 'name'), ', ') : '';
  }
}
